export default __webpack_public_path__ + "static/media/space.1e8f4e2c.wav";